import React, { useState, useEffect } from "react";
import InputTextBox from "../controls/input/InputTextBox";
import * as initialState from "../../services/initialState";
import { GetServiceCharges } from "../../services/commonAPI";
import Modal from "../controls/popup/Modal";

const initialData = initialState.ServiceCharges;

const ServiceCharges = () => {
  const [inputValue, setInputValue] = useState(initialData);

  //declare start
  const [ticketPrice, setTicketPrice] = useState(100);
  const [attendeesPerEvent, setAttendeesPerEvent] = useState(1);
  const [serviceChargesResponse, setServiceChargesResponse] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [taxPayerIs, setTaxPayerIs] = useState("organizer");
  const [pgPayerIs, setPGPayerIs] = useState("organizer");
  const [fitfundaFeePayerIs, setFitfundaFeePayerIs] = useState("organizer");
  // declare end

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  }, []);

  useEffect(() => {
    CallServiceCharges();
    // window.scrollTo(0, 0); // Scroll to top when the component mounts
  }, []);

  //function/events/methods
  const CallServiceCharges = async () => {
    if (inputValue.doesTicketInvolveGst === false) {
      inputValue.gstOrgPercent = 0;
      inputValue.isGstFromAttendees = false;
    } else {
      inputValue.isGstFromAttendees = true;
    }

    const chargesResponse = await GetServiceCharges(inputValue);
    if (chargesResponse?.success) {
      setServiceChargesResponse(chargesResponse?.data);
      setInputValue((prev) => ({
        ...prev,
        ["earningForOrganizer"]: chargesResponse.data.earningForOrganizer,
        ["paidByParticipants"]: chargesResponse.data.paidByParticipants,
        ["processingFee"]: chargesResponse.data.processingFee,
      }));
    } else {
      //alert(chargesResponse?.message);
    }
  };

  const handleGSTSelection = (e) => {
    e.preventDefault();
    inputValue.gstOrgPercent = e.target.value;
    CallServiceCharges();
  };

  const handlePGFeesPayerSelection = (e) => {
    setPGPayerIs(e.target.value);
    inputValue.pgFeesPayer = e.target.value;
    CallServiceCharges();
  };

  const handleHostingFeesPayerSelection = (event) => {
    setFitfundaFeePayerIs(event.target.value);
    inputValue.hostingFeesPayer = event.target.value;
    CallServiceCharges();
  };

  // const handleGSTPayerSelection = (e) => {
  //   setTaxPayerIs(e.target.value);
  //   if (e.target.value === "organizer") {
  //     inputValue.isGstFromAttendees = false;
  //   } else if (e.target.value === "participant") {
  //     inputValue.isGstFromAttendees = true;
  //   }
  //   CallServiceCharges();
  // };

  const handleTicketInvolveGST = (event) => {
    // setInputValue((prev) => ({
    //   ...prev,
    //   doesTicketInvolveGst: event.target.checked,
    // }));
    inputValue.doesTicketInvolveGst = event.target.checked;
    if (event.target.checked) {
      inputValue.gstOrgPercent = 18;
    }
    CallServiceCharges();
  };

  const handleTicketPriceChange = (newValue) => {
    setTicketPrice(newValue);
    inputValue.ticketPricePerEvent = newValue;
    setInputValue(inputValue);
    CallServiceCharges();
  };

  const handleAttendeesChange = (newValue) => {
    setAttendeesPerEvent(newValue);
    inputValue.attendeesPerEvent = newValue;
    setInputValue(inputValue);
    CallServiceCharges();
  };

  const handlePriceInputChange = (e) => {
    const newValue = parseFloat(e.target.value);
    // Check if the parsed value is not NaN (Not a Number)
    if (!isNaN(newValue)) {
      // If the parsed value is valid (not NaN), update the state variable and trigger the change handler
      inputValue.ticketPricePerEvent = newValue;
      setInputValue(inputValue);
      handleTicketPriceChange(newValue);
    }
  };

  const handleAttendeesInputChange = (e) => {
    const newValue = parseInt(e.target.value);
    // Check if the parsed value is not NaN (Not a Number)
    if (!isNaN(newValue)) {
      // If the parsed value is valid (not NaN), update the state variable and trigger the change handler
      inputValue.attendeesPerEvent = newValue;
      handleAttendeesChange(newValue);
      setInputValue(inputValue);
    }
  };

  const handleShowModal = () => {
    setShowModal(true);
  };

  const handleCloseModal = (event) => {
    event.preventDefault();
    setShowModal(() => false);
  };

  // It is only redirecting in mobile mode
  const handleGetStartedClick = (event) => {
    if (window.innerWidth <= 767) {
      // mobile screen width
      event.preventDefault();
      alert("Please switch to our desktop site for a seamless experience.");
    }
  };

  //main return
  return (
    <>
      <div className="service-charges-page">
        <div className=" pricing_page">
          <div className=" d-block">
            <div className="cards_placeholder">
              <div className=" cards_content w-100">
                <div className="d-flex justify-content-center">
                  <div className=" pricing_cards row justify-content-center">
                    <h2 className="jsx-3215938339 choose_the_plan mt-5">
                      All in one event software. Simple and Scalable Pricing for
                      Free & Paid Events.
                      <br />
                      <span>
                        Whatever your business goals, whatever your event
                        strategy - we’ve got a pricing plan that works for you.
                      </span>
                    </h2>
                    <div class="container d-flex justify-content-between">
                      <div className="jsx-3215938339 col-lg-4 col-md-6 col-sm-12 col-xs-12 text-center card mx-4 px-0 mt-5 mb-3">
                        <div className="jsx-3215938339 hosted_event">
                          <span className="jsx-3215938339 service_type">
                            FREE EVENT
                          </span>
                          <span className="jsx-3215938339 percent_value d-flex justify-content-center">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="50"
                              height="90"
                              fill="currentColor"
                              className="bi bi-currency-rupee"
                              viewBox="0 0 16 16"
                            >
                              <path d="M4 3.06h2.726c1.22 0 2.12.575 2.325 1.724H4v1.051h5.051C8.855 7.001 8 7.558 6.788 7.558H4v1.317L8.437 14h2.11L6.095 8.884h.855c2.316-.018 3.465-1.476 3.688-3.049H12V4.784h-1.345c-.08-.778-.357-1.335-.793-1.732H12V2H4z" />
                            </svg>
                            0
                          </span>
                          <span className="jsx-3215938339 pre_booking mb-1">
                            Free For Free Events
                          </span>

                          <div className="jsx-3215938339 px-4">
                            <a href="/create-event" className="jsx-3215938339">
                              <button
                                className="jsx-3215938339 btn outline-btn w-100"
                                onClick={handleGetStartedClick}
                              >
                                Get Started
                              </button>
                            </a>
                          </div>
                        </div>
                      </div>
                      <div className="jsx-3215938339 col-lg-4 col-md-6 col-sm-12 col-xs-12  text-center card mx-4 px-0 mt-5 mb-3">
                        <div className="jsx-3215938339 hosted_event">
                          <span className="jsx-3215938339 service_type">
                            PAID EVENT
                          </span>
                          {/* <div className="jsx-3215938339 table">
                            <div className="jsx-3215938339 table-column">
                              <div className="jsx-3215938339 table-row table-header border-radius-one d-flex justify-content-center align-items-center">
                                Fitfunda Fee: 1.5%
                              </div>
                              {/* <div className="jsx-3215938339 table-row table-content border-radius-two d-flex justify-content-center align-items-center">
                                <span className="jsx-3215938339 percentage-text">
                                  1.75%{" "}
                                </span>
                                Per Ticket*
                              </div> 
                            </div>
                            <div className="jsx-3215938339 table-column">
                              <div className="jsx-3215938339 table-row table-header border-radius-three d-flex justify-content-center align-items-center">
                                Payment Gateway Fee: 1.99%
                              </div>
                              {/* <div className="jsx-3215938339 table-row table-content border-radius-four d-flex justify-content-center align-items-center">
                                <span className="jsx-3215938339 percentage-text">
                                  2%
                                </span>
                                Per Ticket*
                              </div> 
                            </div>
                          </div> */}
                          <div
                            className="jsx-3215938339 pre_booking "
                            style={{ marginTop: "38px" }}
                          >
                            Fitfunda Fee: 1.5%,
                            <br />
                            Payment Gateway Fee: 1.99%
                          </div>
                          <span className="jsx-3215938339 pre_booking">
                            Fees are exclusive of taxes*
                          </span>

                          <div className="jsx-3215938339 px-4">
                            <a href="/create-event" className="">
                              <button
                                className="jsx-3215938339 btn outline-btn w-100 mt-5"
                                onClick={handleGetStartedClick}
                              >
                                Get Started
                              </button>
                            </a>
                          </div>
                        </div>
                      </div>
                      <div className="jsx-3215938339 col-lg-4 col-md-6 col-sm-12 col-xs-12 text-center card mx-4 px-0 mt-5 mb-3">
                        <div className="jsx-3215938339 hosted_event">
                          <span className="jsx-3215938339 service_type">
                            FLEX
                          </span>
                          <span className="jsx-3215938339 pre_booking1 d-flex justify-content-center">
                            {/* <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="60"
                              height="90"
                              fill="currentColor"
                              className="bi bi-currency-rupee"
                              viewBox="0 0 16 16"
                            >
                              <path d="M4 3.06h2.726c1.22 0 2.12.575 2.325 1.724H4v1.051h5.051C8.855 7.001 8 7.558 6.788 7.558H4v1.317L8.437 14h2.11L6.095 8.884h.855c2.316-.018 3.465-1.476 3.688-3.049H12V4.784h-1.345c-.08-.778-.357-1.335-.793-1.732H12V2H4z" />
                            </svg> */}
                            Scalable Pricing,
                            <br />
                            Get in Touch
                            {/* <span className="jsx-3215938339 percentage">%</span> */}
                          </span>
                          {/* <span className="jsx-3215938339 pre_booking mb-5"></span> */}

                          <div className="jsx-3215938339 px-4">
                            <button
                              className="jsx-3215938339 btn outline-btn w-100"
                              onClick={handleShowModal}
                            >
                              Get Started
                            </button>
                          </div>
                        </div>
                        {showModal && (
                          <Modal onClose={handleCloseModal} title="Contact Us">
                            <div class="col-12 ">
                              <p>
                                Vrattanta Endurance & Sports
                                <br />
                                Viman Nagar, Pune.
                              </p>
                              <p>Email: fitfundasupport@vrattanta.com</p>
                              <p>Phone: +91-9529478968</p>
                            </div>
                          </Modal>
                        )}
                      </div>
                    </div>
                    <div class="clearBoth"></div>
                    {/* Feature List */}
                    <div className="feature-heading px-4">
                      Feature for Events
                    </div>
                    <div className="service_content ">
                      <div className="row feature-card p-2">
                        <div className="col-6 feature-list">
                          <div className="feature-item">
                            <img
                              src="./images/tickmark.svg"
                              alt="tick mark"
                              className="tick_style"
                            />
                            <span>
                              Unlimited Events (Free or Paid) and Attendees for
                              any Event
                            </span>
                          </div>
                          <div className="feature-item">
                            <img
                              src="./images/tickmark.svg"
                              alt="tick mark"
                              className="tick_style"
                            />
                            <span>Visualise Event Page while Creation</span>
                          </div>
                          <div className="feature-item">
                            <img
                              src="./images/tickmark.svg"
                              alt="tick mark"
                              className="tick_style"
                            />
                            <span>Customize Participant Form</span>
                          </div>
                          <div className="feature-item">
                            <img
                              src="./images/tickmark.svg"
                              alt="tick mark"
                              className="tick_style"
                            />
                            <span>Discount options - Flat, Code, Group</span>
                          </div>
                          <div className="feature-item">
                            <img
                              src="./images/tickmark.svg"
                              alt="tick mark"
                              className="tick_style"
                            />
                            <span>Configurable Payment Methods</span>
                          </div>
                          <div className="feature-item">
                            <img
                              src="./images/tickmark.svg"
                              alt="tick mark"
                              className="tick_style"
                            />
                            <span>Automatic Weekly Settlements</span>
                          </div>
                        </div>
                        <div className="col-6 feature-list">
                          <div className="feature-item">
                            <img
                              src="./images/tickmark.svg"
                              alt="tick mark"
                              className="tick_style"
                            />
                            <span>Transactions and Settlement Summary</span>
                          </div>
                          <div className="feature-item">
                            <img
                              src="./images/tickmark.svg"
                              alt="tick mark"
                              className="tick_style"
                            />
                            <span>Email & Phone Support</span>
                          </div>
                          <div className="feature-item">
                            <img
                              src="./images/tickmark.svg"
                              alt="tick mark"
                              className="tick_style"
                            />
                            <span>Organizer Dashboard & Event Analytics</span>
                          </div>
                          <div className="feature-item">
                            <img
                              src="./images/tickmark.svg"
                              alt="tick mark"
                              className="tick_style"
                            />
                            <span>Contact Attendees via Email and SMS</span>
                          </div>
                          <div className="feature-item">
                            <img
                              src="./images/tickmark.svg"
                              alt="tick mark"
                              className="tick_style"
                            />
                            <span>
                              Webhook / Event Widget on Organizers Website
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="jsx-3215938339 col-12 settlements-text-div d-flex flex-column justify-content-center align-items-center">
                      <div id="settlements" className="jsx-3215938339">
                        <div
                          id="settlements"
                          className="d-flex justify-content-center align-items-center flex-row automated-main-container g-0"
                        >
                          <div className="container-settlement">
                            {/* <h1 className="settlement-heading">
                              Need Heading Here
                            </h1> */}
                            <div className="content-settlement">
                              <img
                                className="img-settlement"
                                src="./images/AutomatedweeklySettlements.svg"
                                alt="Icon"
                              />
                              <h3 className="settlement-heading">
                                Automated Weekly Settlements
                              </h3>
                              <p className="settlement-sub-text">
                                Receive automated settlements directly to your
                                bank account. All you need to do is provide your
                                bank account details in the event admin
                                dashboard, and our automated system settles
                                funds directly & transparently to your bank
                                account on every thursday.
                              </p>
                            </div>
                          </div>
                        </div>

                        {/* calculator */}

                        <div
                          id="cost-calculator"
                          className="cost-container py-md-3 px-md-5 py-5 px-2"
                        >
                          <div>
                            <div className="row g-0">
                              <div className="col py-md-5">
                                <h2 className="awards-title text-center">
                                  Save your cost with{" "}
                                  <span className="theme-text">Fitfunda</span>
                                </h2>
                                <div className="awards-sub-title w-75 mx-auto">
                                  No upfront, set-up or subscription charges. We
                                  are free for free tickets and Fitfunda Fee
                                  1.5% per ticket plus payment gateway fee and
                                  applicable taxes
                                </div>
                              </div>
                            </div>
                            <div className="cal-body">
                              <div className="calculator">
                                {/* Calculator content */}
                                <h1 className="mb-5 ">
                                  Ticket Price Calculator
                                </h1>
                                <div className="input-container">
                                  <div className="d-flex justify-content-between align-items-center">
                                    <span className="label-text">
                                      Ticket Price*
                                    </span>
                                    <span className="price-value-text">
                                      <input
                                        type="number"
                                        className="price-value-text input-box text-center "
                                        min={0}
                                        max={10000}
                                        value={inputValue.ticketPricePerEvent}
                                        onChange={handlePriceInputChange}
                                        maxlength={5}
                                      />
                                    </span>
                                  </div>

                                  <input
                                    type="range"
                                    id="price"
                                    min={0}
                                    max={10000}
                                    value={ticketPrice}
                                    onChange={(e) =>
                                      handleTicketPriceChange(
                                        parseInt(e.target.value)
                                      )
                                    }
                                  />
                                  <div className="d-flex justify-content-between limit-text">
                                    <span>
                                      From{" "}
                                      {/* <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="16"
                                        // height="90"
                                        fill="white"
                                        class="bi bi-currency-rupee"
                                        viewBox="0 0 16 16"
                                      >
                                        <path d="M4 3.06h2.726c1.22 0 2.12.575 2.325 1.724H4v1.051h5.051C8.855 7.001 8 7.558 6.788 7.558H4v1.317L8.437 14h2.11L6.095 8.884h.855c2.316-.018 3.465-1.476 3.688-3.049H12V4.784h-1.345c-.08-.778-.357-1.335-.793-1.732H12V2H4z"></path>
                                      </svg> */}
                                      ₹ 100
                                    </span>
                                    <span>Limit ₹ 10,000</span>
                                  </div>
                                </div>

                                <div className="input-container">
                                  <div className="d-flex justify-content-between align-items-center">
                                    <span className="label-text">
                                      Attendees Per Event*
                                    </span>
                                    <span className="price-value-text ">
                                      <input
                                        type="number"
                                        className="price-value-text input-box text-center"
                                        min={1}
                                        max={500}
                                        value={inputValue.attendeesPerEvent}
                                        onChange={handleAttendeesInputChange}
                                        maxlength={4}
                                      />
                                    </span>
                                  </div>

                                  <input
                                    type="range"
                                    id="attendees"
                                    min={1}
                                    max={500}
                                    value={attendeesPerEvent}
                                    onChange={(e) =>
                                      handleAttendeesChange(
                                        parseInt(e.target.value)
                                      )
                                    }
                                  />
                                  <div className="d-flex justify-content-between limit-text">
                                    <span>From 1</span>
                                    <span>Limit 500</span>
                                  </div>
                                </div>
                                <div className="divider-line-cal" />
                                <div className="text-start ">
                                  <div className="checkbox-container text-start">
                                    <div class="d-flex flex-row mb-4">
                                      <input
                                        type="checkbox"
                                        id="collect-tax"
                                        name="collect-tax"
                                        value={inputValue.doesTicketInvolveGst}
                                        onChange={handleTicketInvolveGST}
                                      />
                                      <span className="checkbox-label">
                                        Do you want to collect tax?
                                      </span>

                                      {inputValue.doesTicketInvolveGst && (
                                        <div class="d-flex flex-row float-end">
                                          <span
                                            className="checkbox-label"
                                            style={{ marginLeft: "80px" }}
                                          >
                                            Tax % {"  "}
                                          </span>

                                          <InputTextBox
                                            id="gstOrgPercent"
                                            name="gstOrgPercent"
                                            className="gstPercent"
                                            value={inputValue.gstOrgPercent}
                                            placeholder="GST %"
                                            onChange={handleGSTSelection}
                                            maxlength={2}
                                            type="number"
                                            min={"18"}
                                            max={99}
                                          />
                                        </div>
                                      )}
                                    </div>

                                    {/* {inputValue.doesTicketInvolveGst && (
                                      <div className="button-container1 text-start">
                                        <span className=" mt-2 text-start">
                                          Tax Payer{" "}
                                        </span>

                                        <div className="form-check form-check-inline">
                                          <input
                                            className="form-check-input"
                                            type="radio"
                                            name="inlineRadioOptionsTaxes"
                                            id="inlineRadioOptionsTaxes1"
                                            value="organizer"
                                            checked={taxPayerIs === "organizer"}
                                            onChange={handleGSTPayerSelection}
                                            // defaultChecked={true}
                                          />
                                          <label
                                            className="form-check-label"
                                            for="inlineRadio1"
                                          >
                                            Organizer
                                          </label>
                                        </div>

                                        <div class="form-check form-check-inline">
                                          <input
                                            className="form-check-input"
                                            type="radio"
                                            name="inlineRadioOptionsTaxes"
                                            id="inlineRadioOptionsTaxes2"
                                            value="participant"
                                            checked={
                                              taxPayerIs === "participant"
                                            }
                                            onChange={handleGSTPayerSelection}
                                          />
                                          <label
                                            className="form-check-label"
                                            for="inlineRadio1"
                                          >
                                            Participant
                                          </label>
                                        </div>
                                      </div>
                                    )} */}
                                  </div>
                                  <div className="button-container1 text-start">
                                    <span className=" mt-2 text-start">
                                      Payment Gateway{"  "}
                                    </span>

                                    <div class="form-check form-check-inline">
                                      <input
                                        class="form-check-input"
                                        type="radio"
                                        name="inlineRadioOptions"
                                        id="inlineRadio1"
                                        value="organizer"
                                        checked={pgPayerIs === "organizer"}
                                        onChange={handlePGFeesPayerSelection}
                                      />
                                      <label
                                        class="form-check-label"
                                        for="inlineRadio1"
                                      >
                                        Organizer
                                      </label>
                                    </div>

                                    <div class="form-check form-check-inline">
                                      <input
                                        class="form-check-input"
                                        type="radio"
                                        name="inlineRadioOptions"
                                        id="inlineRadio2"
                                        value="participant"
                                        checked={pgPayerIs === "participant"}
                                        onChange={handlePGFeesPayerSelection}
                                      />
                                      <label
                                        class="form-check-label"
                                        for="inlineRadio1"
                                      >
                                        Participant
                                      </label>
                                    </div>
                                  </div>

                                  <div className="button-container2 text-start">
                                    <span className=" mt-2  text-start">
                                      Fitfunda Fee{"    "}
                                    </span>
                                    <div class="form-check form-check-inline">
                                      <input
                                        class="form-check-input"
                                        type="radio"
                                        name="flexRadioDefault"
                                        id="inlineRadio3"
                                        value="organizer"
                                        checked={
                                          fitfundaFeePayerIs === "organizer"
                                        }
                                        onChange={(event) => {
                                          handleHostingFeesPayerSelection(
                                            event
                                          );
                                        }}
                                        defaultChecked={true}
                                      />
                                      <label
                                        class="form-check-label"
                                        for="flexRadioDefault"
                                      >
                                        Organizer
                                      </label>
                                    </div>

                                    <div class="form-check form-check-inline">
                                      <input
                                        class="form-check-input"
                                        type="radio"
                                        name="flexRadioDefault"
                                        id="inlineRadio4"
                                        value="participant"
                                        checked={
                                          fitfundaFeePayerIs === "participant"
                                        }
                                        onChange={(event) => {
                                          handleHostingFeesPayerSelection(
                                            event
                                          );
                                        }}
                                        defaultChecked={false}
                                      />
                                      <label
                                        class="form-check-label"
                                        for="inlineRadio1"
                                      >
                                        Participant
                                      </label>
                                    </div>

                                    {/* <div className="input-container">
                                      <div className="d-flex justify-content-between align-items-center">
                                        <button class="w-100">Calculate</button>
                                      </div>
                                    </div> */}
                                  </div>
                                </div>
                              </div>
                              <div className="earnings-container">
                                {/* Earnings content */}
                                <h1>Your Estimated</h1>
                                <div className="earnings-item mb-4">
                                  <div className="earnings-icon">
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width="55"
                                      height="51"
                                      viewBox="0 0 51 49"
                                      fill="none"
                                    >
                                      <g clip-path="url(#clip0_170_449)">
                                        <path
                                          d="M29.5225 24.3697C29.5225 25.8213 28.9463 27.2135 27.9207 28.2399C26.8951 29.2664 25.5041 29.8431 24.0537 29.8431C22.6033 29.8431 21.2123 29.2664 20.1867 28.2399C19.1611 27.2135 18.585 25.8213 18.585 24.3697C18.585 22.918 19.1611 21.5258 20.1867 20.4994C21.2123 19.4729 22.6033 18.8963 24.0537 18.8963C25.5041 18.8963 26.8951 19.4729 27.9207 20.4994C28.9463 21.5258 29.5225 22.918 29.5225 24.3697ZM26.7881 24.3697C26.7881 23.6438 26.5 22.9478 25.9872 22.4345C25.4744 21.9213 24.7789 21.633 24.0537 21.633C23.3285 21.633 22.633 21.9213 22.1202 22.4345C21.6074 22.9478 21.3193 23.6438 21.3193 24.3697C21.3193 25.0955 21.6074 25.7916 22.1202 26.3048C22.633 26.818 23.3285 27.1064 24.0537 27.1064C24.7789 27.1064 25.4744 26.818 25.9872 26.3048C26.5 25.7916 26.7881 25.0955 26.7881 24.3697ZM7.64746 16.8437C7.64746 14.9554 9.17871 13.4229 11.0654 13.4229H37.042C38.9287 13.4229 40.46 14.9554 40.46 16.8437V31.8956C40.46 33.7839 38.9287 35.3165 37.042 35.3165H11.0654C9.17871 35.3165 7.64746 33.7839 7.64746 31.8956V16.8437ZM11.0654 16.1596C10.8841 16.1596 10.7103 16.2316 10.5821 16.3599C10.4539 16.4883 10.3818 16.6623 10.3818 16.8437V18.8963H11.749C12.1116 18.8963 12.4594 18.7521 12.7158 18.4955C12.9722 18.2389 13.1162 17.8908 13.1162 17.5279V16.1596H11.0654ZM10.3818 31.8956C10.3818 32.2733 10.6881 32.5798 11.0654 32.5798H13.1162V31.2114C13.1162 30.8485 12.9722 30.5005 12.7158 30.2438C12.4594 29.9872 12.1116 29.8431 11.749 29.8431H10.3818V31.8956ZM15.8506 31.2114V32.5798H32.2568V31.2114C32.2568 30.1227 32.689 29.0786 33.4582 28.3087C34.2273 27.5389 35.2706 27.1064 36.3584 27.1064H37.7256V21.633H36.3584C35.2706 21.633 34.2273 21.2005 33.4582 20.4306C32.689 19.6608 32.2568 18.6166 32.2568 17.5279V16.1596H15.8506V17.5279C15.8506 18.6166 15.4185 19.6608 14.6493 20.4306C13.8801 21.2005 12.8368 21.633 11.749 21.633H10.3818V27.1064H11.749C12.8368 27.1064 13.8801 27.5389 14.6493 28.3087C15.4185 29.0786 15.8506 30.1227 15.8506 31.2114ZM34.9912 32.5798H37.042C37.2233 32.5798 37.3972 32.5077 37.5254 32.3794C37.6536 32.2511 37.7256 32.077 37.7256 31.8956V29.8431H36.3584C35.9958 29.8431 35.648 29.9872 35.3916 30.2438C35.1353 30.5005 34.9912 30.8485 34.9912 31.2114V32.5798ZM37.7256 18.8963V16.8437C37.7256 16.6623 37.6536 16.4883 37.5254 16.3599C37.3972 16.2316 37.2233 16.1596 37.042 16.1596H34.9912V17.5279C34.9912 17.8908 35.1353 18.2389 35.3916 18.4955C35.648 18.7521 35.9958 18.8963 36.3584 18.8963H37.7256ZM17.2178 40.7899C16.3516 40.7902 15.5075 40.5161 14.8066 40.0067C14.1056 39.4974 13.5838 38.7791 13.3158 37.9546C13.695 38.0203 14.0842 38.0532 14.4834 38.0532H37.042C38.6737 38.0532 40.2386 37.4044 41.3924 36.2497C42.5461 35.0949 43.1943 33.5287 43.1943 31.8956V19.1289C43.9944 19.412 44.687 19.9364 45.1767 20.63C45.6664 21.3235 45.9292 22.152 45.9287 23.0013V31.8956C45.9287 33.0636 45.6988 34.2202 45.2523 35.2993C44.8056 36.3784 44.1511 37.3589 43.3259 38.1848C42.5006 39.0107 41.521 39.6659 40.4428 40.1128C39.3646 40.5598 38.209 40.7899 37.042 40.7899H17.2178Z"
                                          fill="#5C6ACA"
                                        />
                                      </g>
                                      <defs>
                                        <clipPath id="clip0_170_449">
                                          <rect
                                            width="50"
                                            height="49"
                                            fill="white"
                                            transform="translate(0.746094)"
                                          />
                                        </clipPath>
                                      </defs>
                                    </svg>
                                  </div>
                                  <div className="earnings-label1 text-start">
                                    Paid by participants
                                  </div>
                                  <div
                                    className="earnings-value1"
                                    style={{ marginTop: "21px" }}
                                  >
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width="19"
                                      // height="90"
                                      fill="currentColor"
                                      class="bi bi-currency-rupee"
                                      viewBox="0 0 16 16"
                                    >
                                      <path d="M4 3.06h2.726c1.22 0 2.12.575 2.325 1.724H4v1.051h5.051C8.855 7.001 8 7.558 6.788 7.558H4v1.317L8.437 14h2.11L6.095 8.884h.855c2.316-.018 3.465-1.476 3.688-3.049H12V4.784h-1.345c-.08-.778-.357-1.335-.793-1.732H12V2H4z"></path>
                                    </svg>

                                    {serviceChargesResponse.paidByParticipants}
                                  </div>
                                </div>
                                <div className="earnings-item">
                                  <div className="earnings-icon1">
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      version="1.0"
                                      width="51"
                                      height="35"
                                      viewBox="0 0 512.000000 512.000000"
                                      preserveAspectRatio="xMidYMid meet"
                                    >
                                      <g
                                        transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)"
                                        fill="#5C6ACA"
                                        stroke="none"
                                      >
                                        <path d="M653 4903 c9 -381 63 -588 246 -934 45 -84 81 -158 81 -164 0 -6 -110 -171 -245 -366 -134 -195 -278 -411 -319 -480 -179 -299 -307 -658 -367 -1035 -22 -135 -23 -164 -26 -1031 l-4 -893 2541 0 2540 0 0 800 0 800 -619 0 -620 0 -5 53 c-29 302 -40 371 -86 557 -50 197 -125 400 -211 573 -80 159 -162 288 -413 652 l-254 366 102 202 c109 214 161 354 195 522 21 105 41 289 41 388 l0 57 -75 0 -75 0 0 75 0 75 -1216 0 -1217 0 6 -217z m2273 -163 c-9 -103 -46 -263 -85 -370 -17 -47 -71 -161 -119 -255 l-88 -170 -695 -3 -695 -2 -101 202 c-128 254 -175 402 -190 600 l-6 78 993 0 993 0 -7 -80z m-20 -1477 c144 -208 277 -406 298 -440 121 -203 247 -523 300 -763 29 -133 56 -327 56 -406 l0 -54 -160 0 -160 0 0 -325 0 -325 -785 0 -785 0 0 -325 0 -325 -681 0 -680 0 4 718 c4 773 5 793 62 1047 64 287 184 579 332 810 25 39 153 226 285 418 l240 347 707 0 707 0 260 -377z m1904 -2138 l0 -175 -640 0 -640 0 0 175 0 175 640 0 640 0 0 -175z m-1570 -650 l0 -175 -640 0 -640 0 0 175 0 175 640 0 640 0 0 -175z m1570 0 l0 -175 -640 0 -640 0 0 175 0 175 640 0 640 0 0 -175z" />
                                        <path d="M1340 3191 l0 -149 143 -3 c142 -4 144 -4 219 -42 53 -26 91 -54 123 -89 40 -45 85 -115 85 -133 0 -3 -128 -5 -285 -5 l-285 0 0 -150 0 -150 285 0 c157 0 285 -2 285 -5 0 -17 -43 -86 -78 -125 -88 -100 -198 -140 -384 -140 l-118 0 0 -184 0 -183 400 -344 c221 -189 404 -344 409 -344 9 0 195 214 190 219 -2 1 -149 128 -327 281 l-324 277 74 25 c211 71 378 239 444 447 l22 71 164 5 163 5 3 148 3 147 -164 0 -164 0 -23 70 c-12 38 -39 99 -60 135 l-39 65 225 0 225 0 -3 148 -3 147 -602 3 -603 2 0 -149z" />
                                      </g>
                                    </svg>
                                  </div>
                                  <div className="earnings-label2  text-start">
                                    Earning for organizers
                                  </div>
                                  <div className="earnings-value1">
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width="19"
                                      // height="90"
                                      fill="currentColor"
                                      class="bi bi-currency-rupee"
                                      viewBox="0 0 16 16"
                                    >
                                      <path d="M4 3.06h2.726c1.22 0 2.12.575 2.325 1.724H4v1.051h5.051C8.855 7.001 8 7.558 6.788 7.558H4v1.317L8.437 14h2.11L6.095 8.884h.855c2.316-.018 3.465-1.476 3.688-3.049H12V4.784h-1.345c-.08-.778-.357-1.335-.793-1.732H12V2H4z"></path>
                                    </svg>
                                    {serviceChargesResponse.earningForOrganizer}
                                  </div>
                                </div>
                                <div className="earnings-total">
                                  <div className="earnings-label text-start">
                                    Total
                                  </div>
                                  <div className="earnings-value">
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width="19"
                                      // height="90"
                                      fill="currentColor"
                                      class="bi bi-currency-rupee"
                                      viewBox="0 0 16 16"
                                    >
                                      <path d="M4 3.06h2.726c1.22 0 2.12.575 2.325 1.724H4v1.051h5.051C8.855 7.001 8 7.558 6.788 7.558H4v1.317L8.437 14h2.11L6.095 8.884h.855c2.316-.018 3.465-1.476 3.688-3.049H12V4.784h-1.345c-.08-.778-.357-1.335-.793-1.732H12V2H4z"></path>
                                    </svg>
                                    {serviceChargesResponse.paidByParticipants}
                                  </div>
                                </div>
                                <div className="earnings-fee">
                                  <div className="earnings-label text-start">
                                    Processing Fee
                                  </div>
                                  <div className="earnings-value">
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width="19"
                                      // height="90"
                                      fill="currentColor"
                                      class="bi bi-currency-rupee"
                                      viewBox="0 0 16 16"
                                    >
                                      <path d="M4 3.06h2.726c1.22 0 2.12.575 2.325 1.724H4v1.051h5.051C8.855 7.001 8 7.558 6.788 7.558H4v1.317L8.437 14h2.11L6.095 8.884h.855c2.316-.018 3.465-1.476 3.688-3.049H12V4.784h-1.345c-.08-.778-.357-1.335-.793-1.732H12V2H4z"></path>
                                    </svg>
                                    {serviceChargesResponse.processingFee}
                                  </div>
                                </div>
                                <div className="earnings-estimated">
                                  {/* <div className="earnings-label1 text-start">
                                    Estimated Earnings
                                  </div>
                                  <div className="earnings-value">₹ 204.42</div> */}
                                </div>
                                {/* <div className="earnings-note">
                                  *Provided calculations are approx and
                                  assumption &amp; might vary based on mode of
                                  payment
                                </div> */}
                              </div>
                            </div>

                            <div className="calculator-notes w-75">
                              * Fitfunda Fees & Payment Gateway Fee are
                              inclusive of GST (18%) in this calculator.
                              <br />
                              <br />
                              * Ticket price calculator provides estimated
                              pricing and breakdown for illustrative purposes
                              only. Configurations made are not saved for your
                              event.
                              <br />
                              <br />
                              * Payment gateway charges 1.99% .
                              <br />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ServiceCharges;
